/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import UserService from '@/services/UserService';
import getDrfErrorMessage from '@/components/BranchesAndTeams/drfErrorMessage';

export const changePassword = createAsyncThunk(
  'ChangePasswordModal/changePassword',
  async (arg, { rejectWithValue }) => {
    try {
      return await UserService.changePassword(arg);
    } catch (error) {
      return rejectWithValue(
        error.status ? getDrfErrorMessage(error.response) : null
      );
    }
  }
);
